import _ from 'lodash';

const KEY = 'ALERTBAND';

/**
 * alert :{
 *  id,
 *  content,
 *  variant,
 *  icon,
 *  actionContent:{
 *    title,
 *    action
 *   }
 * }
 */

const initialState = {
  alerts: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${KEY}_SHOW`: {
      const alert = {
        ...action.payload,
        id: _.uniqueId('alert_')
      };

      const alerts = [...state.alerts, alert];

      return {
        ...state,
        alerts
      };
    }

    case `${KEY}_DISMISS`: {
      const alerts = state.alerts.filter(alert => alert.id !== action.payload.id);

      return {
        ...state,
        alerts
      };
    }

    case `${KEY}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
